function concat(...args) {
  let classes = [];
  args.forEach((argument) => {
    if (argument) {
      if (typeof argument === "string") {
        classes.push(argument);
      } else if (Array.isArray(argument)) {
        classes = [...classes, ...argument.map((v) => v)];
      } else if (typeof argument === "object") {
        const keys = Object.keys(argument);
        keys.forEach((key) => {
          if (argument[key]) {
            classes.push(key);
          }
        });
      }
    }
  });
  return classes.join(" ");
}
export {
  concat
};
//# sourceMappingURL=classNames.js.map
